<!-- 高标仓 -->
<template>
    <div class="high-box">
        <div class="high-top">
            <div class="high-export">
                <MessageHeader msg="仓储数据总览"></MessageHeader>
                <el-button @click="exportData"><el-image :src="exportImg"/>数据导出</el-button>
            </div>

            <div class="data-list">
                <el-row :gutter="20">
                    <el-col :span="4" v-for="(item, key, index) in dataList" :key="key">
                        <CompareItem :item="item" :name="keys[key] ? keys[key].str : ''"
                                     :unit="keys[key] ? keys[key].unit : ''"
                                     :process="keys[key] ? keys[key].process : ''"
                                     :top="28"
                                     :index="index"
                                     :itemBgs="[0,1,2,3,4,5,6]"
                                     :tipText="keys[key].tipText"
                        >
                        </CompareItem>
                    </el-col>
                </el-row>
            </div>
            <div class="data-chart">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="chart-style">
                            <p class="u-agg-aii-ct">租户行业分布</p>
                            <div class="chart-style-box">
                                <PieChart :data="dataInfo.industryDistribution"></PieChart>
                            </div>
                        </div>

                    </el-col>
                    <el-col :span="12">
                        <div class="chart-style">
                            <p class="u-agg-aii-ct">市场体量分析</p>
                            <div class="chart-style-box1">
                                <Pies title="总量" :color="['#447FF8', '#AFB7C1']" :data="dataInfo.marketVolume"
                                        y-center :radius="['40%', '50%']" :legend="{
                                        left: 'center',
                                        bottom: 0,
                                        show: true,
                                        orient: 'vertical',
                                        icon: 'circle',
                                        itemWidth: 8,
                                        itemHeight: 8,

                                    }"/>
                                    <div class="chart-center-style">
                                        <span class="jiantou"></span>
                                        <span>现有存量</span>
                                    </div>
                                    <Pies title="现有存量" :color="['#BC5EEB', '#5C67FB']"
                                              :data="dataInfo.currentInventory"
                                              :radius="['30%', '38%']" y-center :legend="{
                                                left: 'center',
                                                bottom: 0,
                                                show: true,
                                                orient: 'vertical',
                                                icon: 'circle',
                                                itemWidth: 8,
                                                itemHeight: 8,
                                            }"/>
                            </div>
                            
                        </div>

                    </el-col>
                </el-row>
            </div>

        </div>

        <div class="child-list">
            <MessageHeader msg="子市场数据一览"></MessageHeader>
            <div class="child-table rs-el-table">
                <el-table :data="childData"
                >
                    <el-table-column prop="areaName" label="区县" width="100" fixed/>
                    <el-table-column sortable prop="existingInventory" label="现有存量（㎡)" align="center" width="200">
                        <template #header>
                            <span class="header-lable">现有存量（㎡)
                                <el-tooltip content="建成面积（包含本季增量）" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="quarterlyIncrease" label="本季度增量(㎡)" align="center" width="200">
                        <template #header>
                            <span class="header-lable">本季度增量（㎡)
                                <el-tooltip content="本季度建成面积" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="netAbsorption" label="净吸纳量(㎡)" align="center" width="200">
                        <template #header>
                            <span class="header-lable">净吸纳量（㎡) </span>
                        </template>

                    </el-table-column>
                    <el-table-column sortable prop="vacancyRate" label="空置率" align="center" width="180">
                        <template #header>
                            <span class="header-lable">空置率</span>
                        </template>
                        <template #default="scope">
                            <span>{{
                                    scope.row.vacancyRate !== null ? Number(scope.row.vacancyRate * 100).toFixed(2) + '%' : scope.row.vacancyRate
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="estimatedEffectiveRent" width="300" align="center">
                        <template #header>
                            <span class="header-lable">预估有效租金(元/㎡·月)
                                <el-tooltip content="折算免租期、装修期后的租金" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                        <template #default="scope">
                            <span>{{
                                    scope.row.estimatedEffectiveRent ? Number(scope.row.estimatedEffectiveRent).toFixed(2) : scope.row.estimatedEffectiveRent
                                }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column sortable prop="estimatedIncrement" width="200" label="预计增量(㎡)" align="center">
                        <template #header>
                            <span class="header-lable">预计增量（㎡)
                                <el-tooltip content="未来三年预计投入市场的面积" placement="top" effect="light">
                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>
                                </el-tooltip>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label=""></el-table-column>

                    <!--                    <el-table-column sortable prop="averageSalesCycle" label="平均去化周期(月)">-->
                    <!--                        <template #header>-->
                    <!--                            <span class="header-lable">平均去化周期(月)-->
                    <!--                                <el-tooltip content="去化10万平所需时间" placement="bottom" effect="light">-->
                    <!--                                    <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65"></i>-->
                    <!--                                </el-tooltip>-->
                    <!--                            </span>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                </el-table>
            </div>

        </div>

        <div class="chart-list">
            <MessageHeader msg="租金与空置率情况"></MessageHeader>
            <div class="chart-items-box">
                <div class="chart-item-left">
                    <p class="u-agg-aii-ct">预估有效租金和空置率趋势</p>
                    <BarAndLineChart
                    color="#0A9BFC"
                    :linearGradient="['rgba(10, 155, 252, 0.8)','rgba(255, 255, 255, 0)']"
                    :options="['name', 'rent', 'vacancyRate']"
                    :data="timeList"
                    ></BarAndLineChart>
                </div>
                <div class="chart-item-right">
                    <p class="u-agg-aii-ct">品牌开发商预估有效租金和空置率趋势</p>
                    <BarAndLineChart
                    color="#31C9E8"
                    :linearGradient="['rgba(49, 201, 232, 0.8)','rgba(255, 255, 255, 0)']"
                    :options="['name', 'rent', 'vacancyRate']"
                    :data="devList"
                    ></BarAndLineChart>
                </div>
            </div>
            <!-- <div class="chart-item">
                <BarAndLine
                    title="预估有效租金和空置率趋势"
                    notShowYName
                    :legend-data="['预估有效租金（元/㎡·月）', '空置率']"
                    :color="['#2C5FE1','#76BAFF', '#FE9A0A']"
                    :showLine="2" :data="timeList"
                    :options="['name', 'rent', 'vacancyRate']"
                    :percentage="['vacancyRate']"/>
            </div>
            <div class="chart-item">
                <BarAndLine
                    title="品牌开发商预估有效租金与空置率情况"
                    notShowYName
                    :legend-data="['预估有效租金（元/㎡·月）', '空置率']"
                    :color="['#0053C2','#41D1FF', '#FE9A0A']"
                    :showLine="0"
                    :data="devList"
                    :options="['name', 'rent', 'vacancyRate']"
                    :percentage="['vacancyRate']"/>
            </div> -->

        </div>

        <div class="dynamic-box">
            <MessageHeader msg="租赁市场动态"></MessageHeader>
            <div class="dynamic-table">
                <ScrollTable :tableHead="tableHead" :table-data="dynamicsData"/>
            </div>
        </div>

    </div>
</template>
<script setup>
import request from "@/service/request";
import {
    dynamicsHighTable, exportCityCold, exportCityHigh,
    getRentAndVacanciesDeveloper,
    getRentAndVacanciesTime,
    getWarehouseChildData,
    getWarehouseData
} from "@/service/api";
import {computed, onMounted, reactive, ref, watch} from "vue";
import CompareItem from '@/components/compareItem'
import MessageHeader from '@/components/MessageHeader'
import Pies from '@/components/charts/chartsPie'
import BarAndLine from '@/components/charts/chartBarAndLine'
import ScrollTable from '@/components/scrollTable'
import PieChart from '@/components/charts/nChartsPie.vue'
import BarAndLineChart from '@/components/charts/nChartBarAndLine.vue'
import exportImg from '@/assets/images/export.png'
import {checkList, searchType} from "@/view/exportData/city";
import {exportFile} from "@/tool/public";
let mapTime = localStorage.getItem('mapTime')

// 导出
const exportData = async () => {
    let data = await request({
        url: exportCityHigh,
        method: 'post',
        data: {
            quarter:[mapTime]
        },
        download: true,
        responseType: 'blob',
    })
    exportFile(data, '高标仓城市层级数据')
}

const props = defineProps({
    code: {
        type: String,
        default: ''
    }
})

watch(() => props.code, () => {
    getWarehouse()
    getChildData()
    getChartInfo()
    getDynamicsData()
})
let dataInfo = ref({})
/** 高标仓数据总览对应关系  **/
const keys = reactive({
    existingInventoryMetric: {str: '现有存量', unit: '㎡', tipText: "建成面积（包含本季增量）"},
    quarterlyIncreaseMetric: {str: '本季度增量', unit: '㎡', tipText: "本季度建成面积"},
    netAbsorptionMetric: {str: '净吸纳量', unit: '㎡'},
    vacancyRateMetric: {str: '空置率', process: '%'},
    estimatedEffectiveRentMetric: {str: '预估有效租金', unit: '元/㎡·月', tipText: "折算免租期、装修期后的租金"},
    estimatedIncrementMetric: {str: '预计增量', unit: '㎡', tipText: "未来三年预计投入市场的面积"},
    // estimatedSalesCycleMetric: { str: '预计去化周期', unit: '月', tipText: "去化10万平所需时间" },
})

const color = ['#447FF8', '#5C67FB', '#BC5EEB', '#F9545A', '#F99807', '#FFC70D', '#7FCD49']

const dataList = ref({})

/**仓储数据总览**/
const getWarehouse = async () => {
    let {data} = await request({
        url: getWarehouseData,
        method: 'get',
        data: {cityCode: props.code}
    })

    let obj = {}
    for (let key in keys) {
        obj[key] = data[key]
    }
    dataList.value = obj
    dataInfo.value = data
}
let childData = ref([])
/** 子市场数据 **/
const getChildData = async () => {
    let {data} = await request({
        url: getWarehouseChildData,
        method: 'get',
        data: {cityCode: props.code}
    })
    data.forEach(item => {
        item.existingInventory = item.existingInventory !== null ? Number(item.existingInventory).toLocaleString() : '';
        item.netAbsorption = item.netAbsorption !== null ? Number(item.netAbsorption).toLocaleString() : '';
        item.estimatedIncrement = item.estimatedIncrement !== null ? Number(item.estimatedIncrement).toLocaleString() : '';
        item.quarterlyIncrease = item.quarterlyIncrease !== null ? Number(item.quarterlyIncrease).toLocaleString() : '';
    })
    childData.value = data
}
/***时间趋势*/
let timeList = ref([])
let devList = ref([])

const getChartInfo = async () => {
    let time = await request({
        url: getRentAndVacanciesTime,
        method: 'get',
        data: {cityCode: props.code}
    })
    console.log(time,'xxx')

    let dev = await request({
        url: getRentAndVacanciesDeveloper,
        method: 'get',
        data: {cityCode: props.code}
    })
    timeList.value = time.data
    devList.value = dev.data
    console.log(timeList,"xxxx123")
}

let dynamicsData = ref([])
const tableHead = ref([
    {props: 'tenantName', label: '租户', align: 'left', width: 280},
    {props: 'areaName', label: '区县', width: 100},
    {props: 'projectName', label: '项目名称', align: 'left'},
    {props: 'statusName', label: '状态', width: 100},
    {props: 'areaValue', label: '租赁/退租面积（㎡）', thousandth: true},
    {props: 'estimatedClosingPrice', label: '预估成交价格（元/㎡·月）', fixed: 2},
])
/**子数据动态**/
const getDynamicsData = async () => {
    let {data} = await request({
        url: dynamicsHighTable,
        method: 'get',
        data: {cityCode: props.code}
    })
    dynamicsData.value = data
}
onMounted(() => {
    getWarehouse()
    getChildData()
    getChartInfo()
    getDynamicsData()
})
</script>

<style lang="less">
@import "../index.less";

.high-box {
    width: 100%;

    .high-top {
        .high-export{
            display: flex;
            justify-content: space-between;
            align-items: center;
            &>.el-button {
                width: 109px;
                height: 36px;
                background: #1477C9;
                border-radius: 4px;
                font-size: 14px;
                font-weight: 400;
                color: #FFFFFF;
                .el-image{
                    width: 16px;
                    height: 15px;
                    margin-right: 8px;
                }
            }
        }
        .data-list {
            .el-row {
                .el-col {
                    margin-top: 20px;
                    height: 235px;
                    //margin-bottom: 20px;
                }

            }
        }

        .data-chart {
            & > .el-row {
                .el-col {
                    margin-top: 20px;
                    //margin-bottom: 20px;
                }

                .margin-0 {
                    margin: 0;
                }
            }

            .chart-style {
                width: 100%;
                box-sizing: border-box;
                padding: 20px;
                padding-bottom: 0;
                height: 360px;
                background: #FFFFFF;
                position: relative;
                box-shadow: -4px 4px 23px 1px rgba(75,173,255,0.1);
                border-radius: 10px;
                display: flex;
                flex-direction: column;
                .chart-style-box{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }
                .chart-style-box1{
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 50px;
                    box-sizing: border-box;
                }
                .chart-style-item {
                    padding-top: 0;
                    width: 100%;
                    box-sizing: border-box;
                    height: 300px;
                    background: #FFFFFF;
                }

                .chart-title {
                    position: absolute;
                    top: 40px;
                    z-index: 9;
                    font-size: 16px;
                    color: @text-color-title;
                    font-weight: 700;
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    width: 100%;
                }

                .chart-center-style {
                    width: 70px;
                    flex-shrink: 0;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    color: #1477C9;
                    font-size: 12px;

                    z-index: 9;

                    .jiantou {
                        display: inline-block;
                        height: 1px;
                        width: 44px;
                        background: #F2F6FE;
                        border: 1px dashed #1477C9;
                        margin-bottom: 5px;
                        position: relative;

                        &::before {
                            content: "";
                            display: block;
                            width: 0;
                            height: 0;
                            border: 6px solid transparent;
                            border-left-color: #1477C9;
                            position: absolute;
                            right: -12px;
                            top: -6px;
                        }
                    }
                }

            }
        }
    }


}
</style>